// @flow

import React from 'react'

import HomePage from 'containers/pages/HomePage'
import SpacePage from 'containers/pages/SpacePage'
import TopicListPage from 'containers/pages/TopicListPage'
import TopicPage from 'containers/pages/TopicPage'
import TweetCampaignPage from 'containers/pages/TweetCampaignPage'
import RoomReputationListPage from 'containers/pages/RoomReputationListPage'
import RoomPage from 'containers/pages/RoomPage'
import FavoriteListPage from 'containers/pages/FavoriteListPage'
import FavoriteListDetailPage from 'containers/pages/FavoriteListDetailPage'
import ReservationListPage from 'containers/pages/ReservationListPage'
import ReservationDetailPage from 'containers/pages/ReservationDetailPage'
import ReservationCancelPage from 'containers/pages/ReservationCancelPage'
import ReservationReputationPage from 'containers/pages/ReservationReputationPage'
import ReservationEditPage from 'containers/pages/ReservationEditPage'
import ReservationChangeHostPage from 'containers/pages/ReservationChangeHostPage'
import ReservationSelectPaymentPage from 'containers/pages/ReservationSelectPaymentPage'
import ReservationPayExaminationPage from 'containers/pages/ReservationPayExaminationPage'
import ReservationChangeGuestPage from 'containers/pages/ReservationChangeGuestPage'
import ReservationChangePaymentPage from 'containers/pages/ReservationChangePaymentPage'
import SearchPage from 'containers/pages/SearchPage'
import Path from './path'

type RenderProps = {
  staticContext: {
    status: number,
  },
}

export default [
  {
    path: '/',
    exact: true,
    component: HomePage,
  },
  {
    path: Path.space(),
    exact: true,
    render: ({ staticContext }: RenderProps) => (
      <SpacePage staticContext={staticContext} />
    ),
  },
  {
    path: Path.topicList(),
    exact: true,
    component: TopicListPage,
  },
  {
    path: Path.topic(),
    exact: true,
    render: ({ staticContext }: RenderProps) => (
      <TopicPage staticContext={staticContext} />
    ),
  },
  {
    path: Path.tweetCampaign(),
    exact: true,
    render: ({ staticContext }: RenderProps) => (
      <TweetCampaignPage staticContext={staticContext} />
    ),
  },
  {
    path: Path.roomReputationList(),
    exact: true,
    component: ({ staticContext }: RenderProps) => (
      <RoomReputationListPage staticContext={staticContext} />
    ),
  },
  {
    path: Path.room(),
    exact: true,
    render: ({ staticContext }: RenderProps) => (
      <RoomPage staticContext={staticContext} />
    ),
  },
  {
    path: Path.dashboard(),
    exact: true,
    component: ReservationListPage,
  },
  {
    path: Path.favoriteLists(),
    exact: true,
    component: FavoriteListPage,
  },
  {
    path: Path.favoriteListDetail(),
    exact: true,
    component: FavoriteListDetailPage,
  },
  {
    path: Path.reservations(),
    exact: true,
    component: ReservationListPage,
  },
  {
    path: Path.reservationDetail(),
    exact: true,
    component: ReservationDetailPage,
  },
  {
    path: Path.reservationMessage(),
    exact: true,
    component: ReservationDetailPage,
  },
  {
    path: Path.reservationCancel(),
    exact: true,
    component: ReservationCancelPage,
  },
  {
    path: Path.reservationReputation(),
    exact: true,
    component: ReservationReputationPage,
  },
  {
    path: Path.reservationEdit(),
    exact: true,
    component: ReservationEditPage,
  },
  {
    path: Path.reservationChangeHost(),
    exact: true,
    component: ReservationChangeHostPage,
  },
  {
    path: Path.reservationSelectPayment(),
    exact: true,
    component: ReservationSelectPaymentPage,
  },
  {
    path: Path.reservationPayExamination(),
    exact: true,
    component: ReservationPayExaminationPage,
  },
  {
    path: Path.reservationChangeGuest(),
    exact: true,
    component: ReservationChangeGuestPage,
  },
  {
    path: Path.reservationChangePayment(),
    exact: true,
    component: ReservationChangePaymentPage,
  },
  {
    path: Path.searchB(),
    exact: true,
    component: SearchPage,
  },
  {
    path: Path.searchMap(),
    exact: true,
    component: SearchPage,
  },
]



// WEBPACK FOOTER //
// ./src/routes/route.jsx